import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { hapticImpact } from "../lib/tg";

export function ModeSwitcher() {
  const { mode, setMode, user } = useAuth();
  const navigate = useNavigate();
  if (!user?.trainer_id) return null;

  return (
    <div className="sticky top-0 z-10 bg-tg-bg border-b border-tg-secondary px-3 py-2 flex justify-center">
      <div className="inline-flex rounded-full bg-tg-secondary p-1 text-sm">
        <button
          className={`px-4 py-1.5 rounded-full transition ${mode === "parent" ? "bg-tg-bg shadow" : "text-tg-hint"}`}
          onClick={() => { hapticImpact(); setMode("parent"); navigate("/"); }}
        >Батько</button>
        <button
          className={`px-4 py-1.5 rounded-full transition ${mode === "trainer" ? "bg-tg-bg shadow" : "text-tg-hint"}`}
          onClick={() => { hapticImpact(); setMode("trainer"); navigate("/t"); }}
        >Тренер</button>
      </div>
    </div>
  );
}
